class ApiSender {

  constructor() {
  }

  async login(username, password) {
    const baseUrl = process.env.REACT_APP_GTW_BASE_URL;
    const payload = {
      username,
      password
    };

    try {
      const response = await fetch(`${baseUrl}/cc/login`, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const result = await response.json();

      if (!response.ok) {
        return {
          success: false,
          message: result.code !== 5000 ? result.message : 'Error Happened'
        };
      }
      const code = result.code;
      if (code === 4001) {
        return {
          success: false,
          message: result.message
        };
      }

      const data = result.data;
      return {
        success: result.status || false,
        message: result.message || 'No description available',
        token: data.token,
        expiration: data.expiration
      };
    } catch (error) {
      console.error("Error login: ", error.message);

      return {
        success: false,
        message: 'Error Happened'
      };
    }
  }

  async search(msisdn) {
    const tokenValid = this.isTokenValid();
    if (!tokenValid) {
      return {
        success: false,
        code: 4001,
        message: 'Unauthorized'
      };
    }
    const token = localStorage.getItem('token');

    const baseUrl = process.env.REACT_APP_GTW_BASE_URL;
    try {
      const response = await fetch(`${baseUrl}/cc/search?msisdn=${msisdn}`, {
        method: 'POST',
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` }
      });

      const result = await response.json();

      if (!response.ok) {
        return {
          success: false,
          code: result.code,
          message: result.code !== 5000 ? result.message : 'Error Happened'
        };
      }

      const code = result.code;
      if (code === 2001) {
        return {
          success: false,
          code: result.code,
          message: result.message
        };
      }

      const data = result.data;
      const empty = !data || data.length === 0;

      const coreFlex = data.find(item => item.serviceName === "CoreFlex") || null;
      const powerPlay = data.find(item => item.serviceName === "PowerPlay") || null;

      return {
        success: result.status || false,
        code: result.code,
        message: result.message || 'No description available',
        empty: empty,
        coreFlex: coreFlex,
        powerPlay: powerPlay
      };
    } catch (error) {
      console.error("Error search: ", error.message);

      return {
        success: false,
        code: 5000,
        message: 'Error Happened'
      };
    }
  }

  async unsubscribe(msisdn, service) {
    const tokenValid = this.isTokenValid();
    if (!tokenValid) {
      return {
        success: false,
        code: 4001,
        message: 'Unauthorized'
      };
    }
    const token = localStorage.getItem('token');

    const baseUrl = process.env.REACT_APP_GTW_BASE_URL;
    try {
      const response = await fetch(`${baseUrl}/cc/${service}/unsubscribe?msisdn=${msisdn}`, {
        method: 'POST',
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` }
      });

      const result = await response.json();

      if (!response.ok) {
        return {
          success: false,
          code: result.code,
          message: result.code !== 5000 ? result.message : 'Error Happened'
        };
      }

      const code = result.code;
      if (code !== 2000) {
        return {
          success: false,
          code: result.code,
          message: result.message
        };
      }

      return {
        success: result.status || false,
        code: result.code,
        message: result.message || 'No description available'
      };
    } catch (error) {
      console.error("Error unsubscribe: ", error.message);

      return {
        success: false,
        code: 5000,
        message: 'Error Happened'
      };
    }
  }

  async refund(msisdn, service, refundType, amount) {
    const tokenValid = this.isTokenValid();
    if (!tokenValid) {
      return {
        success: false,
        code: 4001,
        message: 'Unauthorized'
      };
    }
    const token = localStorage.getItem('token');
    const payload = {
      msisdn,
      refundType,
      amount
    };

    const baseUrl = process.env.REACT_APP_GTW_BASE_URL;
    try {
      const response = await fetch(`${baseUrl}/cc/${service}/refund`, {
        method: 'POST',
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
        body: JSON.stringify(payload)
      });

      const result = await response.json();

      if (!response.ok) {
        return {
          success: false,
          code: result.code,
          message: result.code !== 5000 ? result.message : 'Error Happened'
        };
      }

      const code = result.code;
      if (code !== 2000) {
        return {
          success: false,
          code: result.code,
          message: result.message
        };
      }

      return {
        success: result.status || false,
        code: result.code,
        message: result.message || 'No description available'
      };
    } catch (error) {
      console.error("Error refund: ", error.message);

      return {
        success: false,
        code: 5000,
        message: 'Error Happened'
      };
    }
  }

  async fetchData(msisdn, service) {
    const tokenValid = this.isTokenValid();
    if (!tokenValid) {
      return {
        success: false,
        code: 4001,
        message: 'Unauthorized'
      };
    }
    const token = localStorage.getItem('token');

    const baseUrl = process.env.REACT_APP_GTW_BASE_URL;
    try {
      const response = await fetch(`${baseUrl}/cc/${service}/fetch-data?msisdn=${msisdn}`, {
        method: 'POST',
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` }
      });

      const result = await response.json();

      if (!response.ok) {
        return {
          success: false,
          code: result.code,
          message: result.code !== 5000 ? result.message : 'Error Happened'
        };
      }

      const code = result.code;
      if (code !== 2000) {
        return {
          success: false,
          code: result.code,
          message: result.message
        };
      }

      const data = result.data;
      const empty = !data || data.length === 0;

      return {
        success: result.status || false,
        code: result.code,
        message: result.message || 'No description available',
        empty: empty,
        data: data
      };
    } catch (error) {
      console.error("Error fetch data: ", error.message);

      return {
        success: false,
        code: 5000,
        message: 'Error Happened'
      };
    }
  }

  async saveRequest(msisdn) {
    const tokenValid = this.isTokenValid();
    if (!tokenValid) {
      return {
        success: false,
        code: 4001,
        message: 'Unauthorized'
      };
    }
    const token = localStorage.getItem('token');

    const baseUrl = process.env.REACT_APP_GTW_BASE_URL;
    try {
      const response = await fetch(`${baseUrl}/cc/saveRequest?msisdn=${msisdn}`, {
        method: 'POST',
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` }
      });

      const result = await response.json();

      if (!response.ok) {
        return {
          success: false,
          code: result.code,
          message: result.code !== 5000 ? result.message : 'Error Happened'
        };
      }

      const code = result.code;
      if (code === 2001) {
        return {
          success: false,
          code: result.code,
          message: result.message
        };
      }

      return {
        success: result.status || false,
        code: result.code,
        message: result.message || 'No description available',
      };
    } catch (error) {
      console.error("Error search: ", error.message);

      return {
        success: false,
        code: 5000,
        message: 'Error Happened'
      };
    }
  }

  isTokenValid() {
    const token = localStorage.getItem("token");
    const expiration = localStorage.getItem("expiration");
    if (token === null || token === undefined || token.length === 0 || expiration === null || expiration === undefined || expiration.length === 0) {
      return false;
    }
    const now = new Date();
    const expiryDate = new Date(expiration);
    return (now < expiryDate);
  }
}

export default ApiSender;
